import React, { useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const PolicySection = ({ section, isActive }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (isActive && sectionRef?.current) {
      sectionRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [isActive]);

  return (
    <section 
      ref={sectionRef}
      id={section?.id}
      className={`scroll-mt-24 bg-card border border-border rounded-xl p-6 lg:p-8 transition-all duration-300 ${
        isActive ? 'ring-2 ring-primary/50' : ''
      }`}
    >
      <div className="flex items-start space-x-4 mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
          <Icon name={section?.icon} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
            {section?.title}
          </h2>
        </div>
      </div>
      <div className="prose prose-sm max-w-none text-muted-foreground">
        {section?.content}
      </div>
    </section>
  );
};

export default PolicySection;